import VideoRequestPublic from '@/components/Profile/Video/VideoRequestPublic.vue';

export default [
    {
        name: 'video-request-public',
        path: '/video/request/:hash',
        component: VideoRequestPublic,
        meta: { public: true, hideHeaderButtons: true },
    },
];
